import firebase from "firebase/app";
import {
    GET_REPORT_TITLES,
    GET_USER_DATA,
    SET_FILTER_JOB_STAGE,
    SET_FILTER_USER_UID,
    SET_SEARCH_DATE_FROM,
    SET_SEARCH_DATE_TO,
    SET_REPORT_FILTER_STATE,
    SET_ROWS_PER_PAGE,
    SET_PAGE,
    SET_REPORT_STATUS,
    SET_SELECTED_ROW,
    SET_FILTER_YEAR,
    SET_FILTER_MONTH,
    SET_REPORT_EDIT_STATUS,
    SET_STATUS_CHANGE_MODAL_INFO,
    DELETE_REPORT,
    SET_DELETE_STATUS,
    SET_FILTER_JOB_ID,
} from "./types";
export const getReportTitles = () => {
    return (dispatch) => {
        dispatch({ type: GET_REPORT_TITLES.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/report_titles/`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_REPORT_TITLES.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else {
                    dispatch({ type: GET_REPORT_TITLES.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_REPORT_TITLES.FAIL });
        }
    };
};
export const getUserData = () => {
    return (dispatch) => {
        dispatch({ type: GET_USER_DATA.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/users/`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_USER_DATA.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else {
                    dispatch({ type: GET_USER_DATA.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_USER_DATA.FAIL });
        }
    };
};
export const setFilterUserUid = (uid = "all_users") => {
    return (dispatch) => {
        dispatch({ type: SET_FILTER_USER_UID, payload: uid });
    };
};
export const setFilterJobStage = (reportType = "all_stages") => {
    return (dispatch) => {
        dispatch({ type: SET_FILTER_JOB_STAGE, payload: reportType });
    };
};
export const setYear = (year = false) => {
    return (dispatch) => {
        dispatch({ type: SET_FILTER_YEAR, payload: year });
    };
};
export const setMonth = (month = false) => {
    return (dispatch) => {
        dispatch({ type: SET_FILTER_MONTH, payload: month });
    };
};
export const setSearchDateFrom = (date = false) => {
    return (dispatch) => {
        dispatch({ type: SET_SEARCH_DATE_FROM, payload: date });
    };
};
export const setSearchDateTo = (date = false) => {
    return (dispatch) => {
        dispatch({ type: SET_SEARCH_DATE_TO, payload: date });
    };
};
export const setReportFilterState = (state = false) => {
    return (dispatch) => {
        dispatch({ type: SET_REPORT_FILTER_STATE, payload: state });
    };
};
export const setRowsPerPage = (rows = 50) => {
    return (dispatch) => {
        dispatch({ type: SET_ROWS_PER_PAGE, payload: rows });
    };
};
export const setPage = (page = 1) => {
    return (dispatch) => {
        dispatch({ type: SET_PAGE, payload: page });
    };
};

export const setReportStatus = ({
    status = "unviewed",
    uid = false,
    reportType = false,
    timestamp = false,
} = {}) => {
    return (dispatch) => {
        dispatch({ type: SET_REPORT_STATUS.REQUEST });
        if (uid && reportType && timestamp) {
            try {
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {
                        firebase
                            .database()
                            .ref(`/users/${uid}/reports/${reportType}`)
                            .child(timestamp)
                            .update({ worksheet_status: status })
                            .then(() =>
                                dispatch({ type: SET_REPORT_STATUS.SUCCESS })
                            )
                            .catch(() =>
                                dispatch({ type: SET_REPORT_STATUS.FAIL })
                            );
                    } else {
                        dispatch({ type: SET_REPORT_STATUS.FAIL });
                    }
                });
            } catch {
                dispatch({ type: SET_REPORT_STATUS.FAIL });
            }
        } else {
            dispatch({ type: SET_REPORT_STATUS.FAIL });
        }
    };
};

export const setSelectedRow = (row = false) => {
    return (dispatch) => {
        dispatch({ type: SET_SELECTED_ROW, payload: row });
    };
};
export const setReportEditStatus = ({
    uid = false,
    reportType = false,
    timestamp = false,
    status = false,
} = {}) => {
    return (dispatch) => {
        dispatch({ type: SET_REPORT_EDIT_STATUS.REQUEST });
        if (uid && reportType && timestamp) {
            try {
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {
                        firebase
                            .database()
                            .ref(
                                `/users/${uid}/reports/${reportType}/${timestamp}`
                            )
                            .update({ uneditable: status })
                            .then(() =>
                                dispatch({
                                    type: SET_REPORT_EDIT_STATUS.SUCCESS,
                                })
                            )
                            .catch(() => ({
                                type: SET_REPORT_EDIT_STATUS.FAIL,
                            }));
                    } else {
                        dispatch({ type: SET_REPORT_EDIT_STATUS.FAIL });
                    }
                });
            } catch {
                dispatch({ type: SET_REPORT_EDIT_STATUS.FAIL });
            }
        } else {
            dispatch({ type: SET_REPORT_EDIT_STATUS.FAIL });
        }
    };
};

export const setStatusChangeModal = ({
    state = false,
    status = false,
    uid = false,
    reportType = false,
    timestamp = false,
    type = false,
    subjectName = false,
    subjectChild = false,
} = {}) => {
    return (dispatch) => {
        dispatch({
            type: SET_STATUS_CHANGE_MODAL_INFO,
            payload: {
                state,
                status,
                uid,
                reportType,
                timestamp,
                type,
                subjectName,
                subjectChild,
            },
        });
    };
};
export const deleteReport = ({
    reportType = false,
    uid = false,
    timestamp = false,
    subjectChild = false,
    subjectName = false,
} = {}) => {
    return (dispatch) => {
        dispatch({ type: DELETE_REPORT.REQUEST });
        if (reportType && uid && timestamp && subjectChild && subjectName) {
            try {
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {
                        firebase
                            .database()
                            .ref(
                                `/users/${uid}/reports/${reportType}/${timestamp}`
                            )
                            .remove()
                            .then(() => {
                                firebase
                                    .database()
                                    .ref(
                                        `/subjects/${subjectName}/${subjectChild}/reports/${reportType}/${timestamp}`
                                    )
                                    .remove()
                                    .then(() =>
                                        dispatch({
                                            type: DELETE_REPORT.SUCCESS,
                                        })
                                    )
                                    .catch(() =>
                                        dispatch({ type: DELETE_REPORT.FAIL })
                                    );
                            })
                            .catch(() =>
                                dispatch({ type: DELETE_REPORT.FAIL })
                            );
                    } else {
                        dispatch({ type: DELETE_REPORT.FAIL });
                    }
                });
            } catch {
                dispatch({ type: DELETE_REPORT.FAIL });
            }
        } else {
            dispatch({ type: DELETE_REPORT.FAIL });
        }
    };
};
export const setDeleteStatus = () => {
    return (dispatch) => {
        dispatch({ type: SET_DELETE_STATUS });
    };
};
export const setJobID = (jobID = false) => {
    return (dispatch) => {
        dispatch({ type: SET_FILTER_JOB_ID, payload: jobID });
    };
};
